import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CalendarEvent, CalendarEventVM, EventDetail } from 'app/events/events';
import { ToolsService } from './tools.service';

@Injectable({ providedIn: 'root' })
export class CalendarEventsService {
    baseUrl: string = '';

    constructor(private http: HttpClient, private toolsService: ToolsService, @Inject('BASE_URL') baseUrl: string) {
        this.baseUrl = baseUrl + 'api/tcalevents';
    }

    getCalendarEvents(): Observable<CalendarEventVM[]> {
        return this.http.get<CalendarEventVM[]>(this.baseUrl);
    }

    getCalEventById(id: number): Observable<CalendarEvent> {
        return this.http.get<CalendarEvent>(`${this.baseUrl}/calEvent/${id}`);
    }

    getCalEventVMById(id: number): Observable<CalendarEventVM> {
        return this.http.get<CalendarEventVM>(`${this.baseUrl}/calEventVM/${id}`);
    }

    createCalendarEvent(params: CalendarEvent): Observable<CalendarEvent> {
        return this.http.post<CalendarEvent>(this.baseUrl, params);
    }

    updateCalendarEvent(id: number, calEvent: CalendarEvent): Observable<any> {
        return this.http.put(`${this.baseUrl}/${id}`, calEvent);
    }

    deleteCalendarEvent(id: number): Observable<CalendarEvent> {
        return this.http.delete<CalendarEvent>(`${this.baseUrl}/${id}`);
    }

    getCalendarEventDetailsById(eventId: number): Observable<EventDetail[]> {
        const params = new HttpParams().set('eventId', eventId.toString());
        return this.http.get<EventDetail[]>(`${this.baseUrl}/EventDetails`, { params });
    }

    testMessageLog() {
        return this.http.delete<CalendarEvent>(`${this.baseUrl}/9999`).pipe(
            tap((_) => console.log(`deleted event with id: 9999`)),
            catchError(this.toolsService.handleError<CalendarEvent>('deleteCalendarEvent'))
        );
    }
}
